import { triggerTracking } from '@zoopla/tracking';

const EVENT = 'GAEvent';
const CATEGORY = 'search_filters';

export const trackQuickSearchButtonClick = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'click',
        eventLabel: 'quick_search_bar_open'
    });
};
